<template>
    <v-container fluid>
        <v-carousel
            height="auto"
            cycle
            hide-delimiter-background
            show-arrows-on-hover
        >
            <v-carousel-item
                v-for="(item, i) in slides"
                :key="i"
                :src="item.src"
            >
                <div class="bot-caption d-flex align-center">
                    <div>
                        <h3 class="bot-blue">{{ item.title }}</h3>
                        <h5>{{ item.subtitle }}</h5>
                        <div class="bot-text">{{ item.text }}</div>
                    </div>
                </div>
            </v-carousel-item>
        </v-carousel>
        <a href="googlechrome://xedapgiakho.com">Open in Chrome</a>
        <a
            href="intent://xedapgiakho.com#Intent;scheme=https;action=android.intent.action.VIEW;end"
        >
            Mở trong trình duyệt mặc định
        </a>
        <div class="alert-message">
            <v-alert v-if="!isAuthen" type="success">
                <span>Bạn chưa có tài khoản?</span>
                <v-spacer></v-spacer>
                <v-btn
                    class="ml-2"
                    href="/authen/register"
                    outlined
                    title="Đăng ký"
                    >Đăng ký ngay</v-btn
                >
            </v-alert>
        </div>
    </v-container>
</template>

<script>
export default {
    name: "Home",

    components: {},

    // this is state
    data() {
        return {
            slides: [],
        };
    },

    computed: {
        ua() {
            return this.$store.state.useragent;
        },
        isAuthen() {
            return this.ua && this.ua.member && this.ua.member.MemberID;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.bot-caption {
    max-width: 58%;
}

.bot-caption>div {
    margin-left: 200px;
}

.bot-caption>div h3 {
    font-size: 60px;
}

.bot-caption>div h5 {
    font-size: 32px;
}

.bot-caption>div .bot-text {
    font-size: 22px;
    opacity: 0.8;
}

.alert-message {
    max-width: 600px;
    display: block;
    margin: 0 auto;
}

::v-deep .alert-message .v-alert__content {
    display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// home.vue